
import { EXAMPLE_QUERIES } from '@/utils/searchResults'

export default {
  name: 'SearchNoResults',
  components: {
    LedSearchFormLicencePlate: () =>
      import('@/components/LedSearchFormLicencePlate'),
  },
  props: {
    query: {
      type: String,
      required: true,
    },
    plate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      examples: EXAMPLE_QUERIES,
    }
  },
  computed: {
    plateLabel() {
      return (this.plate || '').toUpperCase()
    },
    domains() {
      return (this.$store.state.domains || []).filter(
        domain => domain.is_active !== false
      )
    },
  },
  mounted() {
    this.$store.dispatch('setDomains')
  },
  methods: {
    domainName(domain) {
      return (domain.name || '').replace(/(\r\n|\n|\r)/gm, ' ')
    },
  },
}
